<template>
  <div class="pay-manangment">
    <el-alert title="" type="warning" v-if="selectPlanInfo.isPay == 1">
      <div class="importantNote">
        <i class="iconfont icon-kaiqi f16 col_FEAF0D mr5"></i>
        当前批次缴费截止时间为<span>{{ endPayTime }}</span>
      </div>
    </el-alert>
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <div>
      <div class="searchCon">
        <div class="searchMain">
          <ots-refer
            :selectList="selectList"
            :request-form="selectForm"
            @search="getResult"
          />
        </div>
      </div>
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableOption="tableOption"
        :tableData="tableData"
        :batchOperBtn="batchOperBtn"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
        @handleSelectionChange="bachOper"
      ></ots-table-group-new>
      <ots-custom-dialog
        :dialog.sync="importDialog"
        title="导入第三方自主缴费"
        width="40%"
      >
        <template v-slot:content>
          <div class="exportDialog">
            <el-form ref="exportForm" :model="importForm">
              <el-form-item>
                <span> 考试批次：{{ currentPlanInfo.name }} </span>
              </el-form-item>
              <el-form-item label="1.模板下载">
                <span
                  style="color: #006aff"
                  @click="$getStaticFile('第三方自主缴费导入模板.xlsx')"
                  class="cp"
                >
                  <i class="el-icon-download"></i>
                  下载导入模板
                </span>
              </el-form-item>
              <el-form-item label="2.选择文件" v-model="importForm.file">
                <ots-upload-file
                  ref="upLoad"
                  :httpRequest="handleFormData"
                  fileType="xlsx"
                />
              </el-form-item>
            </el-form>
            <div class="impExplain">
              <span class="tipTitle"><i></i>提示：</span>
              <div>
                <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
                <div>
                  2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="cancelImportDialog">取消</el-button>
          <el-button round type="primary" @click="rightImport">确定</el-button>
        </template>
      </ots-custom-dialog>
      <ots-custom-dialog
        :dialog.sync="dialogVisible"
        title="导出设置"
        width="40%"
      >
        <template v-slot:content>
          <div class="export-setting">
            <div>请选择数据范围</div>
            <div class="mt10">
              <el-radio-group v-model="actionType">
                <el-radio-button label="1">选中数据</el-radio-button>
                <el-radio-button label="2">查询结果数据</el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <el-button round @click="dialogVisible = false">取消</el-button>
          <el-button round type="primary" @click="exportData">确定</el-button>
        </template>
      </ots-custom-dialog>
    </div>
  </div>
</template>

<script>
import {
  getPayManagementList,
  importPayFn,
  payCourseForOneFn,
  exportCoursePayFn,
} from "@/http/modules/applySet/pay";
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
import {
  getSelectPlanFn,
  getSinglePlan,
  getCurrentPlanFn,
  getPagePlan,
} from "@/http/modules/examSet/examBatch";

import moment from "moment";
export default {
  name: "payManagement",
  data() {
    return {
      importDialog: false,
      dialogVisible: false,
      totalPrice: 0,
      actionType: null,
      selectList: [
        {
          title: "考试批次",
          type: "select",
          requestKey: "planId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "缴费状态",
          type: "select",
          requestKey: "isPay",
          label: "key",
          value: "value",
          data: [
            { key: "全部", value: "" },
            { key: "已缴费", value: "1" },
            { key: "未缴费", value: "0" },
            { key: "退费", value: "2" }
          ],
        },
        {
          title: "报考课程",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          data: [],
        },
        {
          title: "付款方式",
          type: "select",
          requestKey: "payType",
          label: "key",
          value: "value",
          data: [
            {
              key: "全部",
              value: "",
            },
            {
              key: "平台在线缴费",
              value: "1",
            },
            {
              key: "第三方自主缴费",
              value: "2",
            },
          ],
        },
        {
          title: "缴费时间",
          type: "daterange",
          requestKey: "dateRange",
          pickerOptions: {
            shortcuts: [
              {
                text: "今天",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  picker.$emit("pick", [start, end]);
                },
              },
              {
                text: "昨天",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24);
                  picker.$emit("pick", [start, end]);
                },
              },
              {
                text: "最近一周",
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit("pick", [start, end]);
                },
              },
            ],
          },
        },
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          multiple: true,
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          requestKey: "searchKey",
          placeholder: "姓名/证件号",
        },
       
      ],
      selectForm: {
        planId: null,
        isPay: "",
        dateRange: [],
        payDateBegin: "",
        payDateEnd: "",
        payType: "",
        stationId: [""],
        courseId: "",
        orders: "",
        searchKey: "",
        page: 1,
        size: 10,
      },
      tableOption: {},
      tableData: [],
      batchOperBtn: [],
      pagination: {
        total: 0,
      },
      selectPlanInfo: {
        payType: "",
        startPay: "",
        endPay: "",
      },
      importForm: {
        file: "",
      },
      multipleSelectList: [],
      currentPlanId: "",
      currentTime: "",
      currentPlanInfo: {},
    };
  },
  computed: {
    /**
     * @endPayTime 返回缴费截止时间
     */
    endPayTime() {
      return moment(this.selectPlanInfo.endPay).format(
        "YYYY年MM月DD日 HH时mm分ss秒"
      );
    },

    /**
     * @param { 重新配置 导入导出 按钮显示}
     */
    mainTopBtnList() {
      let btnList = [];
      let currentTime = Date.parse(new Date(this.currentTime).toString())
      let start = Date.parse(new Date(this.selectPlanInfo.startPay).toString())


      if (this.currentPlanInfo.classPublish != 1 && currentTime > start && this.currentPlanInfo.payType == 2 ) {
        btnList = [
          {
            title: "导入第三方自主缴费",
            fn: this.showimportDialog,
            plain: true,
          },
          {
            title: "导出",
            fn: this.showExportDialog,
          },
        ];
      } else {
        btnList = [
          {
            title: "导出",
            fn: this.showExportDialog,
          },
        ];
      }
      return btnList;
    },

    /**
     * @tableHeader 表格头动态配置
     */
    tableHeader() {
      let headerList = [
        {
          title: "教学点",
          prop: "stationName",
        },
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "证件号",
          width: "200",
          prop: "cardNo",
        },
        {
          title: "报考课程",
          prop: "courseName",
        },
        {
          title: "缴费金额(元)",
          prop: "money",
        },
        {
          title: "缴费状态",
          prop: "payState",
          type: "tag_Z",
          tagColor: (scope) => {
            const options = {
              已缴费: "col_green",
              未缴费: "col_grayQ",
              退费: "col_grayQ",
            };
            return options[scope.row.payState];
          },
          width: "100",
        },
        {
          title: "缴费时间",
          width: "200",
          prop: "payDate",
        },
        {
          title: "付款方式",
          prop: "payType",
          width: "200",
        },
      ];
      if (this.isShowSetPay) {
        headerList = headerList.concat({
          title: "操作",
          type: "button",
          formatter: (val) => val.row.payState == "未缴费" && this.isShowSetPay ? "<span>第三方自主缴费</span>" : "-",
          disableFn: (val) => val.row.payState == "未缴费" && this.isShowSetPay ? false : true,
          click: this.dealPayLine,
          align: "right",
        });
      }
      return headerList;
    },

    /**
     * @this 可以缴费?true:false
     */
    isShowSetPay() {
      console.log(this.currentPlanInfo)
      let currentTime = Date.parse(new Date(this.currentTime).toString())
      let start = Date.parse(new Date(this.selectPlanInfo.startPay).toString())
      return this.currentPlanInfo.classPublish != 1 && currentTime > start && this.currentPlanInfo.payType == 2
    },
  },
  watch: {
    /**
     * @this 批次切换更新数据
     */
    "selectForm.planId"(val) {
      this.getTableList();
      this.getPlanCourseData(val);
      this.getPlanData(val);
      this.getCurrentPlan();
    },

    /**
     * @this 配置缴费时间范围请求参数
     */
    "selectForm.dateRange"(val) {
      if (val && val.length) {
        this.selectForm.payDateBegin = val[0];
        this.selectForm.payDateEnd = val[1];
      } else {
        this.selectForm.payDateBegin = "";
        this.selectForm.payDateEnd = "";
      }
    },

    /**
     * @this 是否开启导入文件弹窗
     */
    importDialog() {
      this.importForm.file = "";
      this.$refs.upLoad.clearFileName();
    },
  },
  created() {
    this.initSelectData();
  },
  methods: {
    /**
     * @this 重置搜索数据
     */
    resetTableForm() {
      let { planId, size } = this.selectForm;
      this.selectForm = {
        isPay: "",
        dateRange: [],
        payDateBegin: "",
        payDateEnd: "",
        payType: "",
        stationId: [""],
        courseId: "",
        realName: "",
        orders: "",
        cardNo: "",
        planId,
        size,
      };
    },

    /**
     * @this 初始化数据
     */
    initSelectData() {
      this.mixin_getServerTime().then((res) => {
        if (res.code == 1) {
          this.currentTime = res.data;
        }
      });

      getSelectPlanFn({ needAudit: 9 }).then(({ data }) => {
        this.$set(this.selectList[0], "data", data);
        if (data.length) {
          this.selectForm.planId = data[0].id;
        }
      });

      this.mixin_getSelectStation().then((data) => {
        if (data) {
          let stationData = [{ name: "全部", id: "" }].concat(data);
          this.$set(this.selectList[5], "data", stationData);
        }
      });
    },

    /**
     * @param { 获取批次信息 }
     */
    getCurrentPlan() {
      getCurrentPlanFn({ planId: this.selectForm.planId }).then((data) => {
        this.currentPlanId = data.id;
        this.currentPlanInfo = data.data;
      });
    },

    /**
     * @this 获取当前批次课程数据
     */
    getPlanCourseData(planId) {
      getPlanCourseFn({ planId }).then(({ data }) => {
        let courseData = [{ courseName: "全部", courseId: "" }].concat(data);
        this.$set(this.selectList[2], "data", courseData);
        this.selectForm.courseId = courseData[0].courseId;
      });
    },

    /**
     * @this 获取选中批次的数据
     */
    getPlanData(planId) {
      getSinglePlan({ planId }).then(({ data }) => {
        for (let item in this.selectPlanInfo) {
          this.selectPlanInfo[item] = data[item];
        }
      });
    },

    /**
     * @this 获取选中table表格数据
     */
    getTableList() {
      let params = { ...this.selectForm };
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }

      delete params.dateRange;
      getPayManagementList(params).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data.records.map((item) => {
            if (item.payState === "已缴费") {
              item.tagType = "success";
            } else {
              item.tagType = "info";
            }
            return item;
          });
          this.pagination.total = res.data.total;
        }
      });
    },

    /**
     * @this 课程选中
     */

    bachOper(res) {
      this.multipleSelectList = res.map((item) => {
        return item.id;
      });
    },

    /****************************
     * @this 课程选中价格
     ***************************/

    getBillManageTotal() {
      let { page, size, orders, ...params } = this.selectForm;
      this.$api.applyManage.getBillManageTotal(params).then((res) => {
        if (res.code === 1) {
          this.totalPrice = res.data || 0;
        }
      });
    },

    showExportDialog() {
      this.exportData();
    },
    cancelImportDialog() {
      this.importDialog = false;
    },
    showimportDialog() {
      this.importDialog = true;
    },
    handleFormData(val) {
      this.importForm.file = val.file;
    },

    /****************************
     * @this 导入文件
     ***************************/
    async rightImport() {
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const fd = new FormData();
      for (let item in this.importForm) {
        fd.append(item, this.importForm[item]);
      }
      fd.append("planId", this.selectForm.planId);
      const { code, data } = await importPayFn(fd);
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const totalNum = parseInt(data.allCount);
        const successNum = totalNum - failNum;

        let message = `导入完成，成功导入${successNum}，失败人员数${failNum}`;
        this.importDialog = false;

        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address;
          }
        });
        this.getTableList();
      }
    },

    /****************************
     * @this 导出文件
     ***************************/
    exportData() {
      // let { actionType, multipleSelectList } = this;
      // if (!actionType) {
      //   this.$message.warning("请选择查询范围");
      //   return;
      // }
      // if (actionType === "1" && !multipleSelectList.length) {
      //   this.$message.warning("请选择导出数据");
      //   return;
      // }
      let { page, size, orders, ...params } = this.selectForm;
      let newParams = {
        ...params,
      };

      if (typeof newParams.stationId == "object") {
        newParams.stationId = newParams.stationId.join(",");
      }

      exportCoursePayFn(newParams).then((res) => {
        if (res.code === 1) {
          this.dialogVisible = false;
          window.open(res.data);
        }
      });
    },

    /****************************
     * @this 搜索操作
     ***************************/
    getResult() {
      this.selectForm.page = 1;
      this.getTableList();
    },

    /****************************
     * @this 修改学生缴费状态
     ***************************/
    dealPayLine(row) {
      this.$confirm("确认学生已第三方自主缴费？", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          let { cardNo, courseId, planId } = row;
          return payCourseForOneFn({ cardNo, courseId, planId });
        })
        .then(({ code }) => {
          if (code == 1) {
            this.$message.success("操作成功");
            this.getTableList();
          }
        })
        .catch(() => {});
    },

    /****************************
     * @this 分页相关
     ***************************/
    changeSize(num) {
      this.selectForm.size = num;
      this.getTableList();
    },
    changePage(p) {
      this.selectForm.page = p;
      this.getTableList();
    },
  },
};
</script>

<style scoped lang="less">
.total-price {
  padding-bottom: 16px;
  color: #45494d;
  .total-price-label {
    font-size: 13px;
  }
  .price {
    font-size: 20px;
    font-family: Arial-Black, Arial;
    font-weight: 900;
  }
}
.mainCon {
  background: #fff;
  border-radius: 8px;
}
.el-alert {
  margin-bottom: 24px;
  background: #fff5e0;
  border: 1px solid #ff9500;
  height: 48px;
  line-height: 48px;
  box-sizing: border-box;
  .importantNote {
    font-size: 14px;
    color: #ff9500;
    margin-left: -10px;
    margin-top: -7px;
  }
  /deep/ .el-alert__closebtn {
    top: 17px;
    color: #ff9500;
  }
}
</style>
